import React from 'react'

const React_Coding_Practice_21 = () => {
  return (
    <div>
      <h1>Coding Pratice 21</h1>
    </div>
  )
}

export default React_Coding_Practice_21
